function loadScript(url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    script.onload = callback;
    document.head.appendChild(script);
}

loadScript("https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput.min.js", function() {
    var flagnum = document.querySelector("#mobileNumber");
    var flagfield = window.intlTelInput(flagnum, {
        separateDialCode: true,
        hiddenInput: "full_phone",
        initialCountry: "IN",
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
    });

    flagfield.promise.then(function() {
        flagnum.placeholder = "";
    });

    flagnum.addEventListener("input", function() {
        flagnum.placeholder = "";
    });
});